"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cottagesDeposits = void 0;
const termsConditionsTitle = 'Low deposit';
const SIX_WEEKS = 42;
const EIGHT_WEEKS = 56;
const cottages25In2025TermsAndConditionsContent = `
# Booking Conditions

__Cottages.com is a trading name of Awaze Vacation Rentals Ltd.__

We have made it easier for customers to access the terms on which they have made a
booking. Booking conditions apply as at the time when a booking is made.

For all low deposit terms:
[https://www.cottages.com/assets/CDC_low_deposit_May_25.pdf](https://www.cottages.com/assets/CDC_low_deposit_May_25.pdf)
`;
exports.cottagesDeposits = [
    {
        accommodationTypes: ['cottages'],
        amount: 99,
        unitType: 'price',
        termsConditionsContent: `
# Booking Conditions

__Cottages.com is a trading name of Awaze Vacation Rentals Ltd.__

We have made it easier for customers to access the terms on which they have made a booking. Booking conditions apply as at the time when a booking is made.

Current terms and all previous terms can be found within the attached documents

[Cottages.com Deposit Terms](https://www.cottages.com/assets/CDC_low_deposit_March_25.pdf)

[Cottages.com Booking Conditions](https://www.cottages.com/assets/Cottages_Booking_Conditions_October_2024.pdf)
`,
        termsConditionsTitle,
        rules: {
            bookingStartDateMin: new Date('2025-01-01'),
            bookingStartDateMax: new Date('2025-12-31'),
            bookingLeadTimeMin: EIGHT_WEEKS,
            propertySleepsMin: 10,
            propertySleepsMax: 100,
            bookingPriceMin: 0,
            bookingPriceMax: Number.MAX_VALUE,
        },
    },
    {
        accommodationTypes: ['cottages'],
        amount: 25,
        unitType: 'percentage',
        termsConditionsContent: `
# Booking Conditions

__Cottages.com is a trading name of Awaze Vacation Rentals Ltd.__

We have made it easier for customers to access the terms on which they have made a
booking. Booking conditions apply as at the time when a booking is made.

For bookings made between 8 August 2018 and 4 November 2019 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms_8Aug2018to4Nov2019.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_8Aug2018to4Nov2019.pdf)

For bookings made between 5 November 2019 and 1 February 2020 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms_5Nov2019to1Feb2020.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_5Nov2019to1Feb2020.pdf)

For bookings made between 2 February 2020 and 27 February 2020 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms_2Feb2020to27Feb2020.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_2Feb2020to27Feb2020.pdf)

For bookings made from 28 February 2020 to 18 May 2020 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms_28Feb2020to_18May2020.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_28Feb2020to_18May2020.pdf)

For bookings made from 19 May 2020 to 28 July 2020 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms19May2020to28July2020.pdf](https://www.awaze.co.uk/assets/cottages.com_terms19May2020to28July2020.pdf)

For bookings made from 29 July 2020 to 29 December 2020 (inc) –
[https://www.awaze.co.uk/assets/cottages.com_terms_29July2020to29Dec2020.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_29July2020to29Dec2020.pdf)

For bookings made from 30 December 2020 to current date –
[https://www.awaze.co.uk/assets/cottages.com_terms_current.pdf](https://www.awaze.co.uk/assets/cottages.com_terms_current.pdf)
`,
        termsConditionsTitle,
        rules: {
            bookingStartDateMin: new Date('2026-01-01'),
            bookingStartDateMax: new Date('2026-12-31'),
            bookingLeadTimeMin: EIGHT_WEEKS,
            propertySleepsMin: 10,
            propertySleepsMax: 100,
            bookingPriceMin: 0,
            bookingPriceMax: Number.MAX_VALUE,
        },
    },
    {
        accommodationTypes: ['cottages'],
        amount: 25,
        unitType: 'price',
        termsConditionsContent: cottages25In2025TermsAndConditionsContent,
        termsConditionsTitle,
        rules: {
            bookingStartDateMin: new Date('2025-01-01'),
            bookingStartDateMax: new Date('2026-12-31'),
            bookingLeadTimeMin: SIX_WEEKS,
            propertySleepsMin: 0,
            propertySleepsMax: 9,
            bookingPriceMin: 0,
            bookingPriceMax: Number.MAX_VALUE,
        },
    },
];
//# sourceMappingURL=cottagesDeposits.js.map